import React, { useState } from "react";
import sleepCover from "../../../albums/sleep_cover.jpg";
import sleep_song1 from "../../../music/sleep-song1-iiiveloceaffrettato.mp3";
import sleep_song2 from "../../../music/sleep-song2-movementiii.mp3";
import sleep_song3 from "../../../music/sleep-song3-3alwaysatduskno3.mp3";
import PlayerCard from "../PlayerCard";

const SleepOfReason = {
  cover: sleepCover,
  songs: [
    {
      name: "III. Veloce, affrettato!",
      subtitle: "Noémi Győri",
      mp3: sleep_song1,
    },
    {
      name: "Movement III",
      subtitle: "Noémi Győri",
      mp3: sleep_song2,
    },
    {
      name: "Always at Dusk, No. 3",
      subtitle: "Noémi Győri",
      mp3: sleep_song3,
    },
  ],
};

export const SleepOfReasonAlbum = () => {
  const [language, setLanguage] = useState({ eng: "true" }); // Replace with your language context

  return (
    <PlayerCard
      cover={SleepOfReason.cover}
      songs={SleepOfReason.songs}
	  buyLink={"https://classical.music.apple.com/in/album/1816926546"}
	  bookletLink={"https://www.noemigyori.com/sleep-booklet"}
      language={language}
	  listen={true}
    />
  );
};
